module.exports = __webpack_public_path__ + "static/media/sexyshoperotico.57d4f78d.png";